<div class="container-fluid">


  <nav class="navbar navbar-expand-lg bg-body-tertiary">
    <div class="container-fluid">
      <button class="navbar-toggler collapsed" (click)="isCollapsed = !isCollapsed" type="button"
        data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent" [collapse]="isCollapsed">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Summary</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="play">Play</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="recruiter">Recruiter</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="inventory">inventory</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="blacksmith">blacksmith</a>
          </li>
        </ul>
        <div class="btn-group" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
            aria-controls="dropdown-basic">
            Encyclopedia <span class="caret"></span>
          </button>
          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
            <li role="menuitem"><a class="dropdown-item" routerLink="statistics">Combat</a></li>
            <li role="menuitem"><a class="dropdown-item" routerLink="classes">Classes</a></li>
            <li role="menuitem"><a class="dropdown-item" routerLink="skills">Skills</a></li>
            <li role="menuitem"><a class="dropdown-item" routerLink="monsters">Monsters</a>
            <li role="menuitem"><a class="dropdown-item" routerLink="items">Items</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <hr>
  <router-outlet></router-outlet>
</div>